// ============================================================
//  CATEGORÍAS Y DISTANCIAS · Baños Run
//
//  La categoría se asigna según el AÑO DE NACIMIENTO (tabla oficial).
//  Cada distancia solo admite ciertas categorías.
// ============================================================
export const ANIO_EVENTO = 2026;

export interface Categoria {
  nombre: string;
  anioMin: number;
  anioMax: number;
}

export interface Distancia {
  nombre: string;
  categorias: string[];
}

// Categoría según AÑO de nacimiento (ambos años inclusive).
//   Sub16   -> 2011, 2012, 2013
//   Sub18   -> 2009, 2010
//   Sub20   -> 2007, 2008
//   Adultos -> 2006 y anteriores (20 años cumplidos)
export const CATEGORIAS: Categoria[] = [
  { nombre: "Sub16", anioMin: 2011, anioMax: 2013 },
  { nombre: "Sub18", anioMin: 2009, anioMax: 2010 },
  { nombre: "Sub20", anioMin: 2007, anioMax: 2008 },
  { nombre: "Adultos", anioMin: -Infinity, anioMax: 2006 },
];

// Distancias y las categorías que pueden participar en cada una.
export const DISTANCIAS: Distancia[] = [
  { nombre: "Milla (1609m)", categorias: ["Sub16", "Sub18", "Sub20", "Adultos"] },
  { nombre: "5 km", categorias: ["Sub20", "Adultos"] },
  { nombre: "21 km", categorias: ["Adultos"] },
];

// Devuelve la categoría según la fecha de nacimiento (ISO "YYYY-MM-DD").
// "" si no hay fecha; "Sin categoría" si el año no encaja (demasiado joven).
export function asignarCategoria(fechaNacimientoISO: string): string {
  if (!fechaNacimientoISO) return "";
  const anio = new Date(fechaNacimientoISO).getFullYear();
  if (Number.isNaN(anio)) return "";
  const cat = CATEGORIAS.find((c) => anio >= c.anioMin && anio <= c.anioMax);
  return cat ? cat.nombre : "Sin categoría";
}

// Lista de categorías permitidas para una distancia dada.
export function categoriasPermitidas(distancia: string): string[] {
  const d = DISTANCIAS.find((d) => d.nombre === distancia);
  return d ? d.categorias : [];
}

// ¿La categoría puede correr esa distancia?
export function categoriaPermitida(distancia: string, categoria: string): boolean {
  return categoriasPermitidas(distancia).includes(categoria);
}
